<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="bug icon"></i>
      {{ $t("bug report") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img src="/images/icons/bug.png" style="width: 100% !important" />
      </div>
      <div class="description">
        <div class="ui info message">
          {{
            $t(
              "please, provide us explicit information and help us to give you a quickly solution",
            )
          }}
          <i class="smile wink outline icon"></i>
        </div>
        <div class="ui form">
          <div class="field">
            <label for>{{ $t("what's happened?") }}</label>
            <textarea
              name="description"
              rows="6"
              v-model="description"
            ></textarea>
          </div>
        </div>
        <h4 class="ui dividing header">{{ $t("images") }}</h4>
        <file-pond
          name="file"
          ref="pond"
          :label-idle="$t('click or drop files here')"
          v-bind:allow-multiple="true"
          v-bind:allow-revert="false"
          v-bind:server="{
            url: api_host,
            timeout: enterprise_setup.upload_timeout,
            process: {
              url: '/system/do-upload-bug-image',
              method: 'POST',
              headers: {
                'x-access-token': token_session,
              },
              withCredentials: false,
            },
          }"
          v-on:error="filepond_error"
          v-on:processfile="filepond_process"
        />
      </div>
    </div>
    <div class="actions">
      <div class="ui green icon right labeled button" @click="save">
        <i class="check icon"></i>
        {{ $t("ok") }}
      </div>
      <div class="ui blue icon right labeled negative button">
        <i class="close icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, api_host, enterprise_setup, error_toast } from "@/utils";
// import GenericModal from "@/components/GenericModal";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import { v4 } from "uuid";
import html2canvas from "html2canvas";

const FilePond = vueFilePond(FilePondPluginImagePreview);

export default {
  name: "BugModal",
  components: {
    // "generic-modal": GenericModal,
    FilePond,
  },
  computed: {
    token_session() {
      let token = this.$session.get("token");
      return token;
    },
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      api_host: api_host,
      images: [],
      description: "",
    };
  },
  methods: {
    save() {
      let vm = this;
      let isValid = window.jQuery(vm.$refs.form).form("validate form");

      if (isValid) {
        local_api(vm, "post", "/system/do-report-bug", {
          d: vm.description,
          i: vm.images,
        })
          .then(() => {
            window.jQuery(vm.$refs.modal).modal("hide");
          })
          .catch((err) => {
            error_toast(err);
          });
      }
    },
    show_modal() {
      let vm = this;
      window.jQuery(vm.$refs.form).form({
        fields: {
          reason: ["empty"],
        },
      });

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHide() {
            window.jQuery(vm.$refs.form).form("reset");
            vm.$refs.pond.removeFiles();
            vm.images = [];
          },
          onShow() {
            vm.take_screenshot();
          },
        })
        .modal("show");
    },
    // destroy() {
    //   this.$emit("destroy");
    // },
    filepond_error(a, b) {
      console.log("error", a, b);
    },
    filepond_process(event, inst) {
      if (inst.serverId) {
        let r = JSON.parse(inst.serverId);
        if (!r.success) console.log(r.error);
        else {
          this.images.push({
            file_id: v4(),
            server_file: r.data,
            filename: inst.filename,
            filenameWithoutExtension: inst.filenameWithoutExtension,
            fileExtension: inst.fileExtension,
            fileType: inst.fileType,
            fileSize: inst.fileSize,
          });
        }
      }
    },
    take_screenshot() {
      let vm = this;
      html2canvas(document.querySelector("#app")).then((canvas) => {
        var myImage = canvas.toDataURL("image/png");
        vm.$refs.pond.addFile(myImage);
        // console.log(myImage);
      });
    },
  },
  mounted() {
    // let vm = this;
    // window.jQuery(vm.$refs.form).form({
    //   fields: {
    //     reason: ["empty"],
    //   },
    // });
  },
  created() {
    // let vm = this;
    // html2canvas(document.querySelector("#app")).then((canvas) => {
    //   var myImage = canvas.toDataURL("image/png");
    //   vm.$refs.pond.addFile(myImage);
    //   // console.log(myImage);
    // });
    // local_api(vm, "post", "/product/do-get-simple-catalog")
    //   .then(r => {
    //     if (r) {
    //       vm.all_products = r;
    //       this.init_product_dropdown();
    //     }
    //   })
    //   .catch(err => {
    //     error_toast(err);
    //   });
  },
  watch: {},
  updated: function () {},
};
</script>
